import { Button } from 'antd';
import apiCall from 'apps/investment/apiCalls/bank-accounts';
import listByUserApiCall from 'apps/investment/apiCalls/bank-accounts/list-by-user';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import ErrorMessage from 'common/ui/ErrorMessage';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import { useFetchApiGet } from 'hooks/api';
import { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { columnsGenerator } from './config';
import ItemDetail from './detail';

// Bank accounts are listed per user only, at
// /investment/users/:userId/bank-accounts.
export const UserBankAccountListPage = props => {
  const { userId } = useParams();
  return (
    <ListPage
      title="Bank Accounts"
      apiCall={{ list: listByUserApiCall }}
      columnsGenerator={columnsGenerator}
      FilterForm={DynamicFilterForm}
      resourceName="data"
      renderRightHeader={() => (
        <Link to={`/investment/users/${userId}`}>
          <Button>Back to user</Button>
        </Link>
      )}
      {...props}
    />
  );
};

export const UserBankAccountDetailPage = props => {
  const { userId } = useParams();
  return (
    <DetailPage
      title="Bank Account"
      apiCall={apiCall}
      listUrl={`/investment/users/${userId}/bank-accounts`}
      ItemDetail={ItemDetail}
      resourceName="data"
      {...props}
    />
  );
};

// Old URL /investment/bank-accounts/:id: look up the account's user and go
// to the same account under that user.
export const LegacyBankAccountDetailRedirect = () => {
  const { id } = useParams();
  const { data, isLoading, error, load } = useFetchApiGet(apiCall.detail, {
    resourceName: 'data',
  });

  useEffect(() => {
    if (id) load({ id });
  }, [id]);

  if (error) return <ErrorMessage {...(error as any)} />;
  const userId = (data as any)?.user_id;
  if (isLoading || !userId) return <LoadingSpinner />;

  return (
    <Navigate to={`/investment/users/${userId}/bank-accounts/${id}`} replace />
  );
};
